(() => {
  const dialog = document.getElementById('pipet-trio');
  const data = document.getElementById('pipet-trio-data');
  if (!dialog || !data || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const config = JSON.parse(data.textContent);
  const products = config.products.filter(p => p.id && p.variants.some(v => v.available && v.price === 5990));
  const productIds = new Set(config.products.map(p => p.id));
  const words = config.strings;
  const root = window.Shopify?.routes?.root || '/';
  const cards = dialog.querySelector('[data-trio-cards]');
  const submit = dialog.querySelector('[data-trio-submit]');
  const error = dialog.querySelector('[data-trio-error]');
  const seenKey = 'pipet-trio-13990-seen';
  let countAtOpen = 0;
  let choices = [];
  let busy = false;
  let added = false;
  let opening = false;
  let lastFocus;
  const eligible = cart => cart.items.filter(item => productIds.has(item.product_id));
  const count = cart => eligible(cart).reduce((sum, item) => sum + item.quantity, 0);
  const getCart = async () => {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(words.error);
    return response.json();
  };
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const wasSeen = () => {
    try { return sessionStorage.getItem(seenKey) === '1'; } catch { return false; }
  };
  const markSeen = () => {
    try { sessionStorage.setItem(seenKey, '1'); } catch {}
  };
  const close = () => {
    if (busy) return;
    dialog.close();
    lastFocus?.focus({ preventScroll: true });
    document.querySelector('cart-drawer')?.open();
  };
  const baseCard = product => {
    const card = node('article', 'pipet-trio__card');
    const image = node('img', 'pipet-trio__image');
    image.src = product.image;
    image.alt = 'Bandana Pipet ' + product.title;
    image.width = 240;
    image.height = 240;
    image.decoding = 'async';
    const details = node('div', 'pipet-trio__details');
    const name = node('p', 'pipet-trio__name', product.title);
    card.append(image, details);
    details.append(name);
    return { card, image, details, name };
  };
  const existingCard = item => {
    const product = config.products.find(p => p.id === item.product_id);
    const view = baseCard(product);
    view.details.append(node('span', 'pipet-trio__status', '✓ ' + words.in_cart));
    view.details.append(node('span', 'pipet-trio__size-note', words.size + ' ' + item.variant_title));
    return view.card;
  };
  const selectionCard = (initialProduct, index) => {
    const view = baseCard(initialProduct);
    const printLabel = node('label', 'pipet-trio__label', words.print);
    const print = node('select');
    print.id = 'trio-print-' + index;
    printLabel.htmlFor = print.id;
    products.forEach(p => {
      const option = node('option', '', p.title);
      option.value = p.id;
      option.selected = p.id === initialProduct.id;
      print.append(option);
    });
    const sizeLabel = node('label', 'pipet-trio__label', words.size);
    const size = node('select');
    size.id = 'trio-size-' + index;
    sizeLabel.htmlFor = size.id;
    const choice = { variant: null };
    choices.push(choice);
    const fillSizes = product => {
      view.name.textContent = product.title;
      view.image.src = product.image;
      view.image.alt = 'Bandana Pipet ' + product.title;
      size.replaceChildren();
      product.variants.forEach(variant => {
        const available = variant.available && variant.price === 5990;
        const option = node('option', '', variant.title + (available ? '' : ' — ' + words.unavailable));
        option.value = variant.id;
        option.disabled = !available;
        size.append(option);
      });
      const first = product.variants.find(v => v.available && v.price === 5990);
      size.value = first ? String(first.id) : '';
      choice.variant = first?.id;
    };
    print.addEventListener('change', () => fillSizes(products.find(p => String(p.id) === print.value)));
    size.addEventListener('change', () => { choice.variant = Number(size.value); });
    fillSizes(initialProduct);
    view.details.append(printLabel, print, sizeLabel, size);
    return view.card;
  };
  const openForCart = async variantId => {
    if (opening || busy || dialog.open || wasSeen() || products.length < 1) return;
    if (variantId && !config.products.some(p => p.variants.some(v => String(v.id) === String(variantId)))) return;
    opening = true;
    try {
      const cart = await getCart();
      const total = count(cart);
      if (total < 1 || total >= 3 || cart.currency !== 'BRL') return;
      if (eligible(cart).some(item => item.original_price !== 5990)) return;
      cards.replaceChildren();
      choices = [];
      added = false;
      countAtOpen = total;
      for (const item of eligible(cart)) {
        for (let i = 0; i < item.quantity; i++) cards.append(existingCard(item));
      }
      const existingIds = new Set(eligible(cart).map(item => item.product_id));
      const suggestions = [...products.filter(p => !existingIds.has(p.id)), ...products.filter(p => existingIds.has(p.id))];
      for (let i = 0; i < 3 - total; i++) cards.append(selectionCard(suggestions[i % suggestions.length], i));
      dialog.querySelector('[data-trio-description]').textContent = total === 1 ? words.description : words.description_two;
      error.hidden = true;
      submit.textContent = words.complete;
      submit.disabled = false;
      lastFocus = document.activeElement;
      document.querySelector('cart-drawer')?.close();
      dialog.showModal();
      markSeen();
    } catch (e) {
      console.warn('Pipet trio: offer unavailable');
    } finally { opening = false; }
  };
  dialog.querySelectorAll('[data-trio-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => {
    const bounds = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) close();
  });
  submit.addEventListener('click', async () => {
    if (busy) return;
    busy = true;
    submit.disabled = true;
    submit.textContent = words.busy;
    error.hidden = true;
    try {
      const current = await getCart();
      if (!added && count(current) !== countAtOpen) throw new Error(words.changed);
      if (!added) {
        if (choices.some(choice => !choice.variant)) throw new Error(words.choose_size);
        const quantities = new Map();
        choices.forEach(choice => quantities.set(choice.variant, (quantities.get(choice.variant) || 0) + 1));
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [...quantities].map(([id, quantity]) => ({ id, quantity })) })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || words.error);
        added = true;
        dialog.querySelectorAll('select').forEach(select => { select.disabled = true; });
      }
      const drawer = document.querySelector('cart-drawer');
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: config.code, sections: drawer?.getSectionsToRender().map(s => s.section), sections_url: location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(words.error);
      const quantity = count(cart);
      const expected = Math.floor(quantity / 3) * 13990 + (quantity % 3) * 5990;
      const actual = eligible(cart).reduce((sum, item) => sum + item.final_line_price, 0);
      if (actual !== expected) throw new Error(words.discount_error);
      dialog.close();
      if (drawer && cart.sections && Object.values(cart.sections).every(Boolean)) drawer.renderContents(cart);
      else location.assign(root + 'cart');
    } catch (e) {
      error.textContent = e.message || words.error;
      error.hidden = false;
      submit.textContent = added ? words.retry : words.complete;
      if (added) submit.dataset.itemsAdded = 'true';
    } finally {
      busy = false;
      submit.disabled = false;
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source === 'product-form') openForCart(event.productVariantId);
    });
  }
})();
